module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-note"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 3
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('InstructionButtons', {
    attrs: {
      "item": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v("IN" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.title))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.subtitle))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v("N° of steps")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v(_vm._s(_vm.item.steps.length))]), _c('div', {
    staticClass: "field-url-detail",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'instruction',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])], 1)]) : _vm._e(), (_vm.$is('entityList')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 3
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('InstructionButtons', {
    attrs: {
      "item": _vm.item,
      "vehicle": true
    }
  })], 1)], 1), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v("IN" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.instruction.title))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.instruction.subtitle))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v("N° of steps")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v(_vm._s(_vm.item.instruction.steps.length))]), _c('div', {
    staticClass: "field-url-detail",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'instruction',
        params: {
          id: _vm.item.instruction.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c534467!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Instruction.vue
// module id = 2371
// module chunks = 1